var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBucklesLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "48px",
    viewBox: "0 0 36 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Landing",
    transform: "translate(-40.000000, -26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HeaderSection(100vh)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TopNavBar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(40.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buckles-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mark"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#8740FB",
    points: "0 -1.98347108e-05 23.8766281 23.8766083 35.7719008 11.9811372 23.9053884 -1.98347108e-05"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#32E9DB",
    points: "0.000178512397 0.000337190083 0.000178512397 23.9057256 11.9527736 11.9529322 23.9055669 0.000337190083"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#2CE0E2",
    points: "0.000178512397 47.8107769 23.9055669 47.8107769 11.9527736 35.8581818 0.000178512397 23.9055868"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#9865FB",
    points: "0.000178512397 47.8107769 23.9055669 47.8107769 35.7720793 35.8296198 23.8768066 23.9341488"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#2FFDDC",
    points: "0.000178512397 11.9529917 0.000178512397 23.9055868 11.9527736 11.9529917 0.000178512397 0.000396694215"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#6C5AF6",
    points: "0.000178512397 47.8107769 11.9527736 47.8107769 23.9055669 47.8107769 11.9527736 35.8581818"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucklesLogo);
export default __webpack_public_path__ + "static/media/buckles-logo.327b7eacdeece7be9a54b8295dc89933.svg";
export { ForwardRef as ReactComponent };